import React from 'react';
import ReactDOM from 'react-dom/client';
import Produktfinder from './Produktfinder';

// Die Nullprüfung erlaubt es, dass das Bundle auf Magento-Seiten eingebunden
// wird, auf denen absichtlich kein Produktfinder-Mountpoint vorhanden ist.
const mount = document.getElementById('produktfinder');
if (mount) {
  ReactDOM.createRoot(mount).render(
    <React.StrictMode>
      <Produktfinder />
    </React.StrictMode>
  );
}
